import * as _ from 'lodash';

import { tokenize, getRegExpCase, getStringFromRegExp } from '.';
import { ICustomProperties } from '../../models';

const _andTokens = /_AND_/i;
const _orTokens = /_OR_/i;
const _eqToken = '=';
const _starToken = '*';

// Remove beginning and ending star
// ex : *BWART=12_AND_UNIT=kg* => BWART=12_AND_UNIT=kg
const removeStar = (expr: string) => {
    if (expr.length > 0) {
        if (expr[0] === _starToken) {
            expr = expr.substring(1);
            // only remove trailing * if there was one on beginning
            if (expr[expr.length - 1] === _starToken) {
                expr = expr.substring(0, expr.length - 2);
            }
        }
    }
    return expr;
};

const filterEquals = (vm: ICustomProperties, expression: string) => {
    let isMatch = !!vm.customProperties;
    if (isMatch) {
        //expression = `${expression}`;
        const tokenized = tokenize(expression);
        const searchString = tokenized[Object.keys(tokenized)[0]].split(_eqToken);
        // Case with Key=Value
        if (searchString.length === 2) {
            // RegEx for key
            const regularExpressionForKeys = getRegExpCase(searchString[0], true);
            const keys: string[] = Object.keys(vm.customProperties);
            const keysFound = keys.filter(k => regularExpressionForKeys.test(k));
            // RegEx for value
            const regularExpressionForValues = getRegExpCase(searchString[1], true);
            const values = keysFound.map(key => vm.customProperties[key]);
            // Matching
            isMatch = values.filter(v => regularExpressionForValues.test(v)).length > 0;
            // Usual case
        } else {
            const regex = getRegExpCase(expression, true);
            const keys: string[] = Object.keys(vm.customProperties);
            isMatch = keys.filter(k => regex.test(k)).length > 0;
        }
    }
    return isMatch;
};


const filterAnd = (vm: ICustomProperties, expression: string) => {
    const splitted = expression
        .split(new RegExp(_andTokens))
        .filter(s => !!s);

    return _.every(splitted, e => filterEquals(vm, e));
};

const filterOr = (vm: ICustomProperties, expression: string) => {
    const splitted = expression
        .split(new RegExp(_orTokens))
        .filter(s => !!s);

    return _.some(splitted, e => filterAnd(vm, e));
};

export const userFieldParser = (vm: ICustomProperties, regex: RegExp) => {
    // retrieve original search
    const expression = removeStar(getStringFromRegExp(regex));
    // start with or by expression order
    return filterOr(vm, expression);
};